module.exports = __webpack_public_path__ + "img/Product.8afd3d2f.png";